import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import Page from '@/components/content/Page'
import { getCustomerId, getCustomerName } from '@/ducks/customerReducer'
import { getIsPosted, reset } from '@/ducks/newCustomerReducer'
import withCustomerLoaded from '@/hocs/withCustomerLoaded'
import { useIsBechtle } from '@/hooks/user'

import ApplicationForm from './ApplicationForm'
import CustomerTabs from './customer-card/CustomerTabs'
import CustomerInfo from './CustomerInfo'

const Customer = () => {
  const dispatch = useDispatch()

  const isBechtle = useIsBechtle()
  const name = useSelector(getCustomerName)
  const id = useSelector(getCustomerId)
  const isPosted = useSelector(getIsPosted)

  useEffect(() => {
    isPosted && dispatch(reset())
  }, [])

  return (
    <Page className="customer">
      <h1>{name}</h1>

      {!isBechtle && <ApplicationForm customerId={id} />}

      <CustomerInfo />

      <CustomerTabs />
    </Page>
  )
}

export default withCustomerLoaded(Customer)
